module.exports = __webpack_public_path__ + "img/sale-bannar1.1b13cfb1.png";